import React, { useState, useEffect } from "react";
import { Link, useLocation, Outlet } from "react-router-dom";
import "./css/About.scss";

// Components

import TitleBox from "../components/TitleBox";
import Footer from "../components/Footer";

// Icons

import { Shield } from "react-feather";

const Procedures = () => {
  const props = useLocation();

  const [height, setHeight] = useState(window.innerHeight);
  const [width, setWidth] = useState(window.innerWidth);
  const [index, setIndex] = useState(props.state ? props.state.index : 0);

  window.addEventListener("resize", function () {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
  });

  useEffect(() => {
    switch (props.pathname) {
      case "/procedures":
        setIndex(0);
        break;
      case "/procedures/emergency-availment":
        setIndex(0);
        break;
      case "/procedures/out-patient-availment":
        setIndex(1);
        break;
      case "/procedures/in-patient-availment":
        setIndex(2);
        break;
      case "/procedures/dental-availment":
        setIndex(3);
        break;
      default:
        setIndex(0);
        return;
    }
  }, [props.pathname]);

  return (
    <div
      className='about-container'
      style={{
        height: height - 75,
        width: width,
      }}
    >
      <TitleBox title={"Availment Procedures"} />
      <div className='about-us-selection'>
        <div className='indexes'>
          <ul className='selectors' style={{ height: "100%" }}>
            <Link
              to={"/procedures/emergency-availment"}
              onClick={() => setIndex(0)}
            >
              <li className={`list-item ${index === 0 ? "active" : ""}`}>
                <Shield />
                Emergency Availment
              </li>
            </Link>
            <Link
              to={"/procedures/out-patient-availment"}
              onClick={() => setIndex(1)}
            >
              <li className={`list-item ${index === 1 ? "active" : ""}`}>
                <Shield />
                Out-Patient Availment
              </li>
            </Link>
            <Link
              to={"/procedures/in-patient-availment"}
              onClick={() => setIndex(2)}
            >
              <li className={`list-item ${index === 2 ? "active" : ""}`}>
                <Shield />
                In-Patient Availment
              </li>
            </Link>
            <Link
              to={"/procedures/dental-availment"}
              onClick={() => setIndex(3)}
            >
              <li className={`list-item ${index === 3 ? "active" : ""}`}>
                <Shield />
                Dental Availment
              </li>
            </Link>
          </ul>
        </div>
        <div className='inner-container'>
          <Outlet />
        </div>
      </div>
      <Footer
        args={{
          height,
          width,
          styles: {
            height: 50,
            width: width,
            position: "absolute",
            bottom: 0,
          },
        }}
      />
    </div>
  );
};

export default Procedures;
